import type { Drama } from '@/types/drama';

export const dramas: Drama[] = [
  {
    id: 'kind-sister-in-law',
    title: '善良的小姨子',
    subtitle: '温暖治愈的家庭情感大剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20portrait%20poster%20of%20a%20gentle%20young%20woman%20in%20a%20cozy%20sunlit%20living%20room%20holding%20a%20cup%20of%20tea%2C%20soft%20amber%20evening%20light%20through%20linen%20curtains%2C%20family%20emotion%20drama%20mood%2C%20muted%20warm%20color%20palette%2C%20clean%20minimal%20background%2C%20soft%20focus%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-kind-sister-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20cozy%20traditional%20Chinese%20home%20living%20room%20with%20family%20members%20gathered%20together%2C%20soft%20golden%20afternoon%20sunlight%20streaming%20through%20windows%2C%20warm%20amber%20and%20cream%20tones%2C%20gentle%20emotional%20family%20drama%20atmosphere%2C%20clean%20minimal%20composition%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-kind-sister-01&orientation=landscape',
    synopsis: '一场意外之后，善良的小姨子独自扛起照顾姐姐一家的责任，用温柔与坚韧把破碎的生活重新缝合成温暖的家。',
    description: '《善良的小姨子》讲述了一个关于亲情、责任与和解的温情故事。新婚不久，姐姐家中突遭变故，原本无忧无虑的小姨子毅然走进这个摇摇欲坠的家。她用最朴素的善良化解家人之间的隔阂，用日复一日的坚持守住了屋檐下的烟火气。剧中没有激烈的狗血冲突，而是以细腻的生活流笔触，描摹普通人如何在困境中彼此扶持、慢慢找回生活的光。',
    category: '家庭情感',
    tags: ['家庭', '治愈', '都市', '温情'],
    totalEpisodes: 24,
    updatedEpisodes: 24,
    status: '已完结',
    releaseDate: '2025-08-12',
    director: '林嘉树',
    cast: ['苏念', '程亦安', '何清舟'],
    featured: true,
  },
  {
    id: 'neighbor-sunshine',
    title: '邻家暖阳',
    subtitle: '都市治愈系生活剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20poster%20of%20a%20friendly%20young%20woman%20smiling%20on%20a%20sunny%20apartment%20balcony%20surrounded%20by%20green%20plants%2C%20soft%20daylight%2C%20gentle%20urban%20life%20drama%20mood%2C%20warm%20cream%20and%20sage%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-neighbor-sun-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20sunlit%20residential%20alley%20with%20neighbors%20chatting%20by%20the%20doorway%2C%20hanging%20laundry%20and%20potted%20flowers%2C%20soft%20morning%20light%2C%20cozy%20urban%20life%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-neighbor-sun-02&orientation=landscape',
    synopsis: '搬进老小区的年轻女孩，用一杯杯热茶和一次次搭把手，把陌生的邻居处成了最亲近的家人。',
    description: '《邻家暖阳》聚焦一栋老旧居民楼里的烟火人间。刚毕业的女孩搬进这里，从最初的小心翼翼，到逐渐被热情的邻居接纳。每个住户都有各自的烦恼，却总能在楼道里互相照亮。剧集以轻松温暖的节奏，记录平凡人彼此治愈的日常。',
    category: '都市生活',
    tags: ['都市', '群像', '治愈', '日常'],
    totalEpisodes: 20,
    updatedEpisodes: 20,
    status: '已完结',
    releaseDate: '2025-06-03',
    director: '周若帆',
    cast: ['许清妍', '陆则明', '郑一诺'],
    featured: true,
  },
  {
    id: 'alley-households',
    title: '小巷人家',
    subtitle: '年代温情群像剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20retro%20portrait%20poster%20of%20a%20graceful%20woman%20standing%20in%20a%20narrow%20old%20Chinese%20alley%20with%20red%20lanterns%20and%20stone%20walls%2C%20golden%20late%20afternoon%20light%2C%20nostalgic%20period%20drama%20mood%2C%20warm%20sepia%20tones%2C%20clean%20minimal%20composition%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-alley-house-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20nostalgic%20Chinese%20alley%20at%20dusk%20with%20families%20gathered%20outside%20their%20doorways%2C%20bicycles%20and%20wooden%20benches%2C%20golden%20warm%20light%2C%20period%20family%20drama%20atmosphere%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-alley-house-03&orientation=landscape',
    synopsis: '一条老巷，三户人家，几十年的悲欢离合，写尽了中国式家庭最真实的模样。',
    description: '《小巷人家》以一条南方老巷为舞台，跨越数十年时光，讲述几户邻居的命运起伏。柴米油盐里有争执也有守望，时代变迁中有告别也有重逢。剧集用细腻的笔触还原了旧时光里的人情味，让每一位观众都能从中看到自己家的影子。',
    category: '年代温情',
    tags: ['年代', '家庭', '群像', '怀旧'],
    totalEpisodes: 32,
    updatedEpisodes: 32,
    status: '已完结',
    releaseDate: '2025-03-21',
    director: '沈怀远',
    cast: ['方慧兰', '顾成山', '秦小雅'],
    featured: true,
  },
  {
    id: 'warm-journey-home',
    title: '温暖的归途',
    subtitle: '公路治愈情感剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20poster%20of%20a%20young%20woman%20with%20a%20backpack%20looking%20at%20a%20sunny%20country%20road%20from%20a%20car%20window%2C%20soft%20golden%20light%2C%20hopeful%20road%20trip%20drama%20mood%2C%20warm%20amber%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-warm-journey-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20countryside%20road%20at%20sunset%20with%20golden%20fields%20and%20distant%20mountains%2C%20a%20car%20driving%20into%20the%20warm%20light%2C%20hopeful%20emotional%20drama%20atmosphere%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-warm-journey-04&orientation=landscape',
    synopsis: '一次意外的长途旅程，让多年疏远的父女重新学会对话，也找回了家的方向。',
    description: '《温暖的归途》是一场说走就走的公路之旅。倔强的父亲与叛逆的女儿被迫同车远行，一路上争吵、误解、沉默交织，却在无数个黄昏与晨光中慢慢卸下心防。剧集以辽阔的风景与克制的情感，讲述“回家”这个永远动人的主题。',
    category: '家庭情感',
    tags: ['公路', '亲情', '治愈', '成长'],
    totalEpisodes: 18,
    updatedEpisodes: 18,
    status: '已完结',
    releaseDate: '2025-05-09',
    director: '叶秋白',
    cast: ['江晚舟', '白舒宁', '唐启山'],
  },
  {
    id: 'years-like-song',
    title: '岁月如歌',
    subtitle: '青春怀旧成长剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20nostalgic%20portrait%20poster%20of%20a%20young%20woman%20in%20a%20record%20shop%20holding%20headphones%2C%20soft%20warm%20light%20through%20windows%2C%20youth%20memory%20drama%20mood%2C%20muted%20vintage%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-years-song-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20nostalgic%20old%20school%20campus%20playground%20at%20golden%20hour%20with%20students%20and%20trees%2C%20soft%20warm%20light%2C%20youth%20coming%20of%20age%20atmosphere%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-years-song-05&orientation=landscape',
    synopsis: '四个少年在旧磁带与老歌里，走过了兵荒马乱又闪闪发光的青春。',
    description: '《岁月如歌》回望一段属于九十年代的青春。街角的音像店、泛黄的歌词本、操场边的蝉鸣，构成了少年们最珍贵的记忆。剧集在怀旧的底色上，讲述友谊、懵懂的爱与各自的抉择，让长大后的我们重新听见当年的心跳。',
    category: '青春成长',
    tags: ['青春', '怀旧', '成长', '友情'],
    totalEpisodes: 26,
    updatedEpisodes: 22,
    status: '更新中',
    releaseDate: '2025-10-01',
    director: '何蔚然',
    cast: ['林知夏', '程越', '孟晓阳'],
  },
  {
    id: 'look-of-home',
    title: '家的模样',
    subtitle: '都市家庭关系剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20poster%20of%20a%20kind%20middle%20aged%20woman%20in%20a%20bright%20modern%20kitchen%20cooking%2C%20soft%20daylight%2C%20domestic%20family%20drama%20mood%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-look-of-home-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20bright%20modern%20dining%20table%20with%20a%20family%20sharing%20dinner%2C%20warm%20lamp%20light%20in%20the%20evening%2C%20cozy%20domestic%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-look-of-home-06&orientation=landscape',
    synopsis: '三代同堂的一家人，在磕磕绊绊中学习如何真正地理解彼此、经营一个家。',
    description: '《家的模样》把镜头对准一个普通的都市家庭。婆媳的分寸、夫妻的默契、亲子的代沟，每一处都是生活本来的样子。剧集不回避矛盾，也从不吝啬温暖，最终告诉我们：家不是没有裂缝，而是有人愿意把裂缝补上。',
    category: '都市生活',
    tags: ['都市', '家庭', '代际', '现实'],
    totalEpisodes: 30,
    updatedEpisodes: 30,
    status: '已完结',
    releaseDate: '2025-04-18',
    director: '陆行舟',
    cast: ['宋佳宜', '周慕白', '罗敏'],
  },
  {
    id: 'spring-courtyard',
    title: '春日小院',
    subtitle: '田园治愈慢生活',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20poster%20of%20a%20serene%20woman%20tending%20flowers%20in%20a%20sunny%20cottage%20courtyard%2C%20soft%20spring%20daylight%2C%20peaceful%20countryside%20drama%20mood%2C%20fresh%20green%20and%20cream%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-spring-court-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20peaceful%20countryside%20courtyard%20in%20spring%20with%20blooming%20flowers%20and%20a%20wooden%20house%2C%20soft%20morning%20sunlight%2C%20calm%20healing%20atmosphere%2C%20fresh%20natural%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-spring-court-07&orientation=landscape',
    synopsis: '告别城市喧嚣的女孩，在乡下小院开了一间花房，也重新种回了自己的生活。',
    description: '《春日小院》是一段慢下来的时光。主角辞去高压的工作，回到外婆留下的小院，用花草、饭菜与邻里的人情味，一点点治愈疲惫的自己。剧集以舒缓的节奏和明亮的画面，献给每一个想要喘口气的人。',
    category: '治愈日常',
    tags: ['田园', '治愈', '慢生活', '成长'],
    totalEpisodes: 16,
    updatedEpisodes: 16,
    status: '已完结',
    releaseDate: '2025-02-14',
    director: '温向晚',
    cast: ['顾南枝', '夏远', '柴婆婆'],
  },
  {
    id: 'ordinary-years',
    title: '平凡岁月',
    subtitle: '现实主义家庭剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20realistic%20portrait%20poster%20of%20a%20hardworking%20woman%20in%20a%20modest%20city%20home%20sewing%20by%20warm%20lamp%20light%2C%20soft%20evening%20glow%2C%20grounded%20family%20drama%20mood%2C%20muted%20warm%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-ordinary-years-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20modest%20city%20street%20at%20golden%20hour%20with%20shopkeepers%20and%20bicycles%2C%20soft%20warm%20light%2C%20grounded%20realistic%20drama%20atmosphere%2C%20muted%20warm%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-ordinary-years-08&orientation=landscape',
    synopsis: '一对普通夫妻用三十年的相濡以沫，把最平凡的日子过成了最深的浪漫。',
    description: '《平凡岁月》讲述两个普通人携手走过的漫长时光。没有惊天动地的情节，只有租房、加班、养娃、还贷的真实琐碎。剧集以平实的镜头语言，致敬每一对在生活里默默坚持的平凡人。',
    category: '年代温情',
    tags: ['现实', '家庭', '年代', '生活'],
    totalEpisodes: 28,
    updatedEpisodes: 28,
    status: '已完结',
    releaseDate: '2025-01-26',
    director: '孟长川',
    cast: ['刘玉华', '张建国', '孙晓芳'],
  },
  {
    id: 'under-the-eaves',
    title: '屋檐下',
    subtitle: '温情舍友生活剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20portrait%20poster%20of%20three%20young%20women%20laughing%20together%20on%20a%20cozy%20apartment%20sofa%2C%20soft%20warm%20lamp%20light%2C%20friendly%20urban%20life%20drama%20mood%2C%20warm%20neutral%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-under-eaves-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20cozy%20shared%20apartment%20living%20room%20at%20night%20with%20warm%20string%20lights%2C%20soft%20evening%20glow%2C%20friendly%20urban%20living%20atmosphere%2C%20warm%20neutral%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-under-eaves-09&orientation=landscape',
    synopsis: '三个性格迥异的女孩因合租住进同一屋檐，在鸡飞狗跳里成了彼此的底气。',
    description: '《屋檐下》描绘当代都市青年的合租生活。生活习惯的碰撞、工作的压力、感情的心事，都被这间小小的出租屋温柔接住。剧集轻松幽默又不失真诚，讲述陌生人在同屋檐下慢慢成为家人的故事。',
    category: '都市生活',
    tags: ['都市', '友情', '群像', '治愈'],
    totalEpisodes: 22,
    updatedEpisodes: 12,
    status: '更新中',
    releaseDate: '2025-09-15',
    director: '苏晚晴',
    cast: ['叶知秋', '李茉', '陈小满'],
  },
  {
    id: 'towards-the-sun',
    title: '一路向阳',
    subtitle: '励志成长情感剧',
    cover: 'https://readdy.ai/api/search-image?query=Warm%20hopeful%20portrait%20poster%20of%20a%20determined%20young%20woman%20looking%20toward%20bright%20sunlight%2C%20soft%20golden%20glow%2C%20inspiring%20growth%20drama%20mood%2C%20warm%20amber%20tones%2C%20clean%20minimal%20background%2C%20editorial%20poster%20photography&width=600&height=900&seq=cover-towards-sun-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20wide%20scene%20of%20a%20young%20woman%20walking%20on%20a%20sunlit%20city%20street%20toward%20bright%20morning%20light%2C%20hopeful%20inspiring%20atmosphere%2C%20warm%20golden%20tones%2C%20editorial%20cinematography&width=1600&height=900&seq=banner-towards-sun-10&orientation=landscape',
    synopsis: '屡屡碰壁的追梦女孩，靠着一股不服输的劲儿，在城市的缝隙里长成了自己的太阳。',
    description: '《一路向阳》讲述一个普通女孩的奋斗之路。从小城到都市，她经历求职的挫败、现实的重压与自我的怀疑，却始终没有放弃对生活的热爱。剧集以明亮的基调，献给每一个在困境中依然选择向前的人。',
    category: '青春成长',
    tags: ['励志', '成长', '都市', '温情'],
    totalEpisodes: 24,
    updatedEpisodes: 24,
    status: '已完结',
    releaseDate: '2025-07-07',
    director: '林知远',
    cast: ['向晴', '顾言川', '苏禾'],
  },
];